export default __webpack_public_path__ + "static/media/photo--lg--84.35de6129.jpg";